import { collectionGroup, collection, getDocs, getDoc, doc, updateDoc, deleteDoc,
  setDoc, Timestamp, serverTimestamp, where, query, orderBy, limit, addDoc, startAfter,
  OrderByDirection, getCountFromServer, deleteField } from "firebase/firestore";
import { db } from "../firebase";
import { Company } from "../model/Companies";
import { UserItemMaping, User, UserData, ReadMessages, Passcode, AttendingGroups, APP_USE, GetAppUseStateFromUserData } from "../model/Users";
import systemParametersQuery from "./SystemParameters.query";
import { CreateState } from "../model/Systemparameters";
import messagesQuery from "./Messages.query";
import { Messages } from "../model/Message";
import { requestGetRdbAttendingGroups } from "../api/Messages.api";
import { EventParticipationHistory } from "../model/EventParticipationHistory";

const userQuery = {
  // 利用者詳細
  getUser: async (tenantId: string, userId: string) => {
    console.log("user getUser access");
    const userRef = await getDoc(
      doc(db, `/companies/${tenantId}/users`, userId)
    );
    const user = userRef.data();
    return UserItemMaping(user as User);
  },
  // 利用者リスト取得
  getUserList: async (company: Company) => {
    console.log("user getUserList access");
    const usersRef = await getDocs(query(
      collection(db, `companies/${company.id}/users`),
      where('deleteAt', '==', null),
    ));
    return usersRef.docs.map((doc) => doc.data());
  },
  // 利用者リスト指定件数取得
  getPagedUserList: async (
    company: Company,
    sortCol: string,
    sortOrder: OrderByDirection,
    page: number,
    datalimit: number,
  ) => {
    console.log("user getPagedUserList access");
    const usersRef = await getDocs(
      query(
        collection(db, `companies/${company.id}/users`),
        where('deleteAt', '==', null),
        orderBy(sortCol, sortOrder),
        startAfter((page - 1) * datalimit),
        limit(datalimit)
      )
    );
    return usersRef.docs.map((doc) => doc.data());
  },
  // 削除済みを含めた利用者リスト総件数取得
  getAllUserListLength: async (companyId: string) => {
    console.log("user getAllUserListLength access");
    const usersRef = await getCountFromServer(
      collection(db, `companies/${companyId}/users`)
    );
    return usersRef.data().count;
  },
  // 利用者リスト総件数取得
  getUserListLength: async (companyId: string): Promise<number> => {
    console.log("user getUserListLength access");
    const usersRef = await getCountFromServer(
      query(
        collection(db, `companies/${companyId}/users`),
        where('deleteAt', '==', null)
      )
    );
    return usersRef.data().count;
  },
  // アプリ利用可能件数取得
  getAppAvailableLength: async (companyId: string): Promise<number> => {
    console.log("user getAppAvailableLength access");
    const usersRef = await getCountFromServer(
      query(
        collection(db, `companies/${companyId}/users`),
        where('deleteFlg', '==', false),
        where('accountSuspensionFlg', '==', false)
      )
    );
    return usersRef.data().count;
  },
  // アプリ利用不可件数取得
  getAppUnavailableLength: async (companyId: string): Promise<number> => {
    console.log("user getAppUnavailableLength access");
    const usersRef = await getCountFromServer(
      query(
        collection(db, `companies/${companyId}/users`),
        where('deleteFlg', '==', true)
      )
    );
    return usersRef.data().count;
  },
  // デバイス登録されている利用者IDリスト取得
  getDevicesDocId: async ()
    :Promise<{success: boolean, data:string[]}> => {
    try {
      console.log("user getDevicesDocId access");
      const devicesRef = await getDocs(collectionGroup(db, `devices`));
      if(devicesRef.docs.length < 1) {
        throw new Error()
      }
      const result = devicesRef.docs.map((doc) => doc.ref.parent.parent?.id ?? '0');
      return {success: true, data: result};
    }catch (err: any) {
      console.error(err);
      return {success: false, data: []};
    }
  },
  // 指定ユーザのデバイスデータを削除
  deleteDevices: async (tenantId: string, uesrId: string) => {
    const ref = await getDocs(collection(db, `/companies/${tenantId}/users/${uesrId}/devices`));
    await Promise.all(ref.docs.map(async (document): Promise<void> => {
      await deleteDoc(doc(db, document.ref.path));
    }));
  },
  // アクティブな利用者リスト取得
  getActiveUserList: async (company: Company) => {
    console.log("user getUserList access");
    const usersRef = await getDocs(
      query(
        collection(db, `companies/${company.id}/users`),
        where('lastName', '!=', ''),
        where('accountSuspensionFlg', '==', false)
      )
    );
    return usersRef.docs.map((doc) => doc.data());
  },

  // アクティブな利用者リストをdisplayId順に取得 
  getActiveUserListSort: async (company: Company) => {
    console.log("user getActiveUserListSort access");

    // 件数のみ取得
    const countQuery = query(
      collection(db, `companies/${company.id}/users`),
      where('lastName', '!=', ''),
      where('accountSuspensionFlg', '==', false),
      where('deleteFlg', '==', false)
    );
    const snapshot = await getCountFromServer(countQuery);
    const count = snapshot.data().count;

    // 最後のユーザー1件だけ取得
    const lastUserQuery = query(
      collection(db, `companies/${company.id}/users`),
      where('lastName', '!=', ''),
      where('accountSuspensionFlg', '==', false),
      where('deleteFlg', '==', false),
      orderBy("displayId", "desc"),
      limit(1)
    );
    const lastUserSnapshot = await getDocs(lastUserQuery);
    const lastUser = lastUserSnapshot.docs[0]?.data();

    return {
      count,
      lastUserDisplayId: lastUser?.displayId ?? null,
    };
  },

  // アクティブな利用者リスト総件数取得
  getActiveUserListLength: async (companyId: string): Promise<number> => {
    console.log("user getUserList access");
    const usersRef = await getCountFromServer(
      query(
        collection(db, `companies/${companyId}/users`),
        where('lastName', '!=', ''),
        where('accountSuspensionFlg', '==', false)
      )
    );
    return usersRef.data().count;
  },

  // パスコード取得
  getPasscode: async (tenantId: string, userId: string): Promise<Passcode[] | any> => {
    console.log("user getPasscode access");
    try {
      const passcodeRef = await getDocs(
        query(collection(db, `companies/${tenantId}/users/${userId}/passcode`),
          orderBy('createAt', 'asc'),
          limit(1)));
      return passcodeRef.docs.map((doc) => doc.data() as Passcode);
    } catch (err: any) {
      console.error(err);
      return err;
    }
  },
  // パスコード登録
  addPasscode: async (tenantId: string, userId: string, passcode: Passcode)
    : Promise<Passcode | string> => {
    console.log("user addPasscode access");
    try {
      const docRef = await addDoc(collection(db, `companies/${tenantId}/users/${userId}/passcode`), passcode);
      await updateDoc(docRef, {id: docRef.id});
      const result = await getDoc(docRef);
      return result.data() as Passcode;
    } catch (err: any) {
      console.error(err);
      return err;
    }
  },
  // パスコード更新
  updatePasscode: async (tenantId: string, userId: string, passcode: Passcode)
    : Promise<Passcode | string> => {
    console.log("user updatePasscode access");
    try {
      const passcodeRef = await getDocs(
        query(collection(db, `companies/${tenantId}/users/${userId}/passcode`),
          orderBy('createAt', 'asc'),
          limit(1)));
      const targetId = passcodeRef.docs.map((doc) => doc.id)[0];
      const docRef = doc(db, `companies/${tenantId}/users/${userId}/passcode/${targetId}`);
      await updateDoc(docRef, passcode);
      const result = await getDoc(docRef);
      return result.data() as Passcode;
    } catch (err: any) {
      console.error(err);
      return err;
    }
  },
  // パスコード更新（ログアウト用）
  updatePasscodeForLogout: async(tenantId: string, userId: string) => {
    // パスコードを取得
    const docPass = await userQuery.getPasscode(tenantId, userId);
    if (0 < docPass.length) {
      const docRef = doc(db, `companies/${tenantId}/users/${userId}/passcode/${docPass[0].id}`);

      // ダミー項目を追加して更新
      await updateDoc(docRef, {"dummy": ""});
      // ダミー項目を削除
      await updateDoc(docRef, {"dummy": deleteField()});
    }
  },
  // 所属グループ取得
  getGroups: async (userId: string) => {
    console.log("user getGroups access");
    const attendingGroupsRef = await getDocs(
      query(collectionGroup(db, "attendingGroups"),
        where('userId', '==', userId)));
    return attendingGroupsRef.docs.map((group) => group.data());
  },
  // 利用者グループ一括取得
  getAttendingGroups: async (tenantId: string) => {
    console.log("user getAttendingGroups access");
    const attendingGroupsRef = await getDocs(
      query(collectionGroup(db, "attendingGroups"),
        where('tenantId', '==', tenantId)));
    return attendingGroupsRef.docs.map((group) => group.data());
  },
  // 所属しているグループの件数を取得
  getGroupUserCount: async (tenantId: string, groupId: string): Promise<number> => {
    console.log("user getGroupUserCount access");
    const q = query(
      collectionGroup(db, "attendingGroups"),
      where("tenantId", "==", tenantId),
      where("id", "==", groupId)
    );
    const snapshot = await getCountFromServer(q);
    return snapshot.data().count;
  },
  // グループに所属している利用者一覧取得
  getGroupsUser: async (groupId: string, tenantId: string) => {
    console.log("user getGroupsUser access");
    const attendingGroupsRef = await getDocs(
      query(collectionGroup(db, "attendingGroups"),
        where('id', '==', groupId),
        where('tenantId', '==', tenantId)));
    return attendingGroupsRef.docs.map((group) => group.data());
  },
  // グループに所属している利用者取得
  getGroupsUserData: async (groupId: string, tenantId: string, userId: string) => {
    console.log("user getGroupsUser access");
    const attendingGroupsRef = await getDocs(
      query(collectionGroup(db, "attendingGroups"),
        where('id', '==', groupId),
        where('tenantId', '==', tenantId),
        where('userId', '==', userId)));
    return attendingGroupsRef.docs.map((group) => group.data());
  },
  // グループに所属している利用者取得（件数）
  getGroupsUserCount: async (groupId: string, tenantId: string) => {
    const snap = await getCountFromServer(
      query(
        collectionGroup(db, "attendingGroups"),
        where("id", "==", groupId),
        where("tenantId", "==", tenantId)
      )
    );
    return snap.data().count;
  },
  // グループに所属している管理者取得（件数）
  getAdminCount: async (groupId: string, tenantId: string) => {
    const snap = await getCountFromServer(
      query(
        collectionGroup(db, "attendingGroups"),
        where("id", "==", groupId),
        where("tenantId", "==", tenantId),
        where("adminFlg", "==", true)
      )
    );
    return snap.data().count;
  },
  // 利用者グループの管理者権限更新
  updateAdminFlg: async (tenantId: string, changeAdminFlgList: string[], isChecked: boolean, groupId: string) => {
    console.log("user updateAdminFlg access");
    await Promise.all(changeAdminFlgList.map(async (userId) => {
      await updateDoc(doc
        (db, `/companies/${tenantId}/users/${userId}/attendingGroups`,`${groupId}`),
        {adminFlg: isChecked},
      );
    }));
  },
  // 利用者に所属グループ登録
  addAttendingGroups: async (tenantId: string, userId: string, groupId: string) => {
    // 現在日付取得
    const addDate = new Date();
    await setDoc(doc(db, `/companies/${tenantId}/users/${userId}/attendingGroups/${groupId}`),
      {id: groupId, userId: userId, tenantId: tenantId, addDate: addDate}
    );
  },
  // 利用者の所属グループ削除
  deleteAttendingGroups: async (tenantId: string, userId: string, groupId: string) => {
    await deleteDoc(doc(db, `/companies/${tenantId}/users/${userId}/attendingGroups/${groupId}`),
    );
  },
  // 利用者情報更新
  updateUser: async (tenantId: string, user: UserData, companyDisplayId: string): Promise<boolean> => {
    try {
      console.log("user updateUser access");
      // 利用者情報更新
      const userRef = doc(db, `/companies/${tenantId}/users`, user.id);
      const userData: any = {
        id: user.id ?? '',
        tenantId: user.tenantId ?? '',
        lastName: user.lastName ?? '',
        lastNameKana: user.lastNameKana ?? '',
        phoneNumber: user.phoneNumber ?? '',
        faxNumber: user.faxNumber ?? '',
        iconURL: user.iconURL ?? '',
        familyEmail: user.familyEmail?.split(",") ?? [],
        groupCount: user.groups.length ?? 0,
        devicesCount: user.devicesCount ?? 0,
        updateAt: serverTimestamp(),
        admin: user.admin,
        deleteFlg: user.deleteFlg,
        accountSuspensionFlg: user.accountSuspensionFlg,
        note: user.note ?? '',
        zipCode: user.zipCode ?? '',
        address: user.address ?? '',
        searchKey1: user.searchKey1 ?? '',
        searchKey2: user.searchKey2 ?? '',
        searchKey3: user.searchKey3 ?? '',
        pointAssignmentAuthority: user.pointAssignmentAuthority === undefined || user.pointAssignmentAuthority === null ? deleteField() : user.pointAssignmentAuthority,
      }
      const appUse = GetAppUseStateFromUserData(user);

      // 更新前のユーザ情報を取得
      const beforeUser = await getDoc(userRef);
      const beforeUserData = beforeUser.data();
      const beforeUserItem = UserItemMaping(beforeUserData as User);
      const beforeUserAppUse = GetAppUseStateFromUserData(beforeUserItem);

      // 誕生日の型を判定
      if(user.birthDate !== undefined){
        const birthDate = Number.isNaN(new Date(user.birthDate).getTime())
          ? undefined
          : Timestamp.fromDate(new Date(user.birthDate));
        if(birthDate !== undefined) {
          userData.birthDate = birthDate;
        } else {
          userData.birthDate = deleteField();
        }
      } else {
        userData.birthDate = deleteField();
      }

      // 性別がundefinedの場合フィールドを削除
      if (user.sex !== undefined && user.sex !== null) {
        userData.sex = user.sex;
      } else {
        userData.sex = deleteField();
      }
      // 運営者アプリを利用不可にした場合
      if(user.admin === false) {
        // ポイント管理を削除
        userData.pointAssignmentAuthority = deleteField();
      }

      // 利用停止に変更した場合
      if(beforeUserAppUse !== APP_USE.SUSPEND && appUse === APP_USE.SUSPEND){
        // ポイント管理利用不可に変更
        userData.pointAssignmentAuthority = false;
      }

      // ユーザ情報更新
      await updateDoc(userRef, userData)

      // グループ更新
      const attendingGroupsRef = await getDocs(collection(db, `/companies/${tenantId}/users/${user.id}/attendingGroups`));
      // allと団体番号のグループ、選択しているグループ以外削除（チェックを外したグループを削除）
      const noDeleteList = ["all",companyDisplayId];
      await Promise.all(user.groups.map(async (group) => {
        noDeleteList.push(group.id);
      }))
      const deleteList = attendingGroupsRef.docs.filter((doc) => !noDeleteList.includes(doc.id));
      await Promise.all(deleteList.map(async (document): Promise<void> => {
        await deleteDoc(doc(db, document.ref.path));
      }));
      // 選択しているグループを追加
      await Promise.all(user.groups.map(async (group) => {
        const check = attendingGroupsRef.docs.filter((doc) => doc.id === group.id);
        // 新規追加時に所属日時を設定（既に登録されている場合は何もしない）
        if(check.length === 0){
          await userQuery.addAttendingGroups(tenantId, user.id, group.id);
        }
      }));
      // 利用停止に変更した場合
      if(beforeUserAppUse !== APP_USE.SUSPEND && appUse === APP_USE.SUSPEND){
        // グループ登録情報削除
        const noDeleteList = ["all",companyDisplayId];
        const deleteList = attendingGroupsRef.docs.filter((doc) => !noDeleteList.includes(doc.id));
        await Promise.all(deleteList.map(async (document): Promise<void> => {
          await deleteDoc(doc(db, document.ref.path));
        }));

        // デバイス登録情報削除
        await userQuery.deleteDevices(tenantId, user.id);
        // パスコード更新：ログアウト用
        await userQuery.updatePasscodeForLogout(tenantId, user.id);

        // 空の利用者を1件作成
        const userNum = await userQuery.getAllUserListLength(user.tenantId);
        const createState: CreateState = {
          id: "",
          tenantId: user.tenantId,
          userCount: userNum + 1,
          createCount: 0,
          status: "standBy",
          startUserId: userNum + 1,
        }
        await systemParametersQuery.addCreateState(createState);
      }
      // 役割を利用者、またはアプリ利用不可に変更した場合
      if (user.admin === false || appUse === APP_USE.UNUSEABLE) {
        // グループ管理者権限を削除
        const noChangeList = ["all",companyDisplayId];
        const changeAdminFlgList = attendingGroupsRef.docs.filter((doc) => !noChangeList.includes(doc.id));
        const beforeAdminFlgList = changeAdminFlgList.map((doc) => doc.data() as AttendingGroups);
        await Promise.all(beforeAdminFlgList.map(async (item) => {
          await updateDoc(
            doc(db,`/companies/${tenantId}/users/${item.userId}/attendingGroups`,`${item.id}`),
            {adminFlg: false});
        }));
      }

      // アプリ利用不可に変更した場合
      if (!beforeUserItem.deleteFlg && (appUse === APP_USE.UNUSEABLE)) {
        // デバイス登録情報削除
        await userQuery.deleteDevices(tenantId, user.id);
        // パスコード更新：ログアウト用
        await userQuery.updatePasscodeForLogout(tenantId, user.id);
      }

      return true;
    } catch (err) {
      console.error(err)
      return false;
    }
  },
  // 対象の返信データ取得
  getTargetReadMessages: async (tenantId: string, userId: string, messageId: string) => {
    console.log("user getTargetReadMessages access");
    const readMessagesRef = await getDocs(
      query(
        collection(db, `companies/${tenantId}/users/${userId}/readMessages`),
        where('messageId', '==', messageId)
      )
    );
    const items = readMessagesRef.docs.map((readMessage) => readMessage.data() as ReadMessages);
    return items.length > 0 ? items.at(0)! : null;
  },
  // 返信、出欠ボタン・チェックボックス更新
  updateReplyButton: async (tenantId: string, readMessages: ReadMessages, confirmed: boolean, message: Messages): Promise<boolean> => {
    console.log("user updateReplyButton access");
    try {
      if (confirmed) {
        // eventParticipationHistory更新
        const q = query(
          collection(db, `messages/${readMessages.messageId}/eventParticipationHistory`),
          where("userId", "==", readMessages.userId)
        );
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          // 確定後、利用者の追加を行う場合
          const user = await userQuery.getUser(message.tenantId, readMessages.userId) as UserData;
          // データがない場合、新規追加
          let publishTarget = message.select ?? '';
          let publishTargetList: string[] = [];
          if (publishTarget === 'topic') {
            // グループ配信
            const gragResult = await requestGetRdbAttendingGroups(message.tenantId, ['id'], true);
            if (gragResult.success) {
              publishTargetList = (message.topic ?? []).filter(groupId => groupId && gragResult.data.map((ag: { id: any; }) => ag.id).includes(groupId));
            }
          }
          let addData: EventParticipationHistory = {
            attendanceButtonName: "会場で参加",
            confirmationCheck: true,
            createdAt: new Date(),
            deleteFlg: false,
            eventAt: message.eventAt,
            eventType: message.eventType ?? null,
            eventVenue: message.eventVenue ?? null,
            id: "",
            isMunicipalityConfirmed: message.municipalityConfirmedFlg ?? false,
            isStaffConfirmed: message.staffConfirmedFlg ?? false,
            lastName: user.lastName ?? '',
            messageId: message.id,
            participationFlg: true,
            publishTarget: publishTarget,
            publishTargetList: publishTargetList,
            readAt: null,
            replyButtonName: "未回答",
            sendDate: message.sendDate,
            tenantId: message.tenantId,
            title: message.title,
            updatedAt: new Date(),
            userDisplayId: user.displayId ?? '',
            userId: user.id,
          };
          const newDocRef = await addDoc(collection(db, `messages/${readMessages.messageId}/eventParticipationHistory`), addData);
          // 新規追加後にIDを設定
          await updateDoc(newDocRef, { id: newDocRef.id });
        } else {
          // 利用者が存在する場合、データ更新
          querySnapshot.forEach(async (doc) => {
            await updateDoc(doc.ref, {
              attendanceButtonName: readMessages.attendanceButtonName ?? deleteField(),
              confirmationCheck: readMessages.confirmationCheck ?? false,
              updatedAt: new Date(),
            });
          });
        }
      }
      // readMessages更新
      const docRef = doc(db, `companies/${tenantId}/users/${readMessages.userId}/readMessages/${readMessages.messageId}`);
      // undefined のフィールドを削除
      const cleanedReadMessages: Partial<ReadMessages> = {};
      Object.keys(readMessages).forEach(key => {
        const value = readMessages[key as keyof ReadMessages];
        if (value !== undefined) {
          (cleanedReadMessages as any)[key] = value;
        }
      });
      if (!readMessages.eventAt) {
        cleanedReadMessages.eventAt = message.eventAt;
      }
      if (!readMessages.sendDate) {
        cleanedReadMessages.sendDate = message.sendDate;
      }
      await setDoc(docRef, cleanedReadMessages, { merge: true });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  },  

  // 出欠ボタン未選択状態更新
  clearAttendanceButton : async (tenantId: string, userId: string, confirmed: boolean, message: Messages): Promise<boolean> => {
    console.log("user clearAttendanceButton access");
    try {
      if(confirmed){
        // 確定時のみeventParticipationHistory更新
        const q = query(
          collection(db, `messages/${message.id}/eventParticipationHistory`),
          where("userId", "==", userId)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach(async (doc) => {
          await updateDoc(doc.ref, {
            "attendanceButtonName": deleteField(),
          });
        });
      }
      const docRef = doc(db, `companies/${tenantId}/users/${userId}/readMessages/${message.id}`);
      await updateDoc(docRef, {
        attendanceButtonName: deleteField(),
        attendanceAt: deleteField()
      });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  // 団体の運営者一覧を取得
  getAdminUserList: async (companyId: string,) => {
    console.log("user getAdminUserList access");
    const usersRef = await getDocs(
      query(
        collection(db, `companies/${companyId}/users`),
        where('admin', '==', true)
      )
    );
    return usersRef.docs.map((doc) => doc.data());
  },

  //指定されたsearchNameを持つユーザーを検索
  getUserBySearchName: async(tenantId: string, searchKeysName: string, searchName: string): Promise<User | null> => {
    try {
      const usersRef= collection(db, `companies/${tenantId}/users`);
      const updateUsers = query(usersRef, where(`${searchKeysName}`, '==', searchName));
      const querySnapshot = await getDocs(updateUsers)
      if (querySnapshot.empty) {
        return null;
      }
      const userDoc = querySnapshot.docs[0];
      const userData = userDoc.data();
      return {
        id: userDoc.id,
        tenantId,
        updateAt: userData.updateAt?.toDate?.() ?? new Date(), 
        admin: userData.admin ?? false, 
        deleteFlg: userData.deleteFlg ?? false,
        [searchKeysName]: userData.searchName,
        accountSuspensionFlg: userData.accountSuspensionFlg,
      };
    } catch (error) {
      console.error("エラーが発生しました:", error);
      return null; 
    }
  },

  // ユーザの検索キーを更新
  updateUserSearchName: async (tenantId: string, userId: string, searchKeysName: string, newSearchName: string): Promise<void> => {
    try {
      const userDocRef = doc(db, `companies/${tenantId}/users`, userId);
      await updateDoc(userDocRef, {
        [searchKeysName]: newSearchName,
      });
    } catch (error) {
      console.error(`ユーザーの更新中にエラーが発生しました:`, error);
      throw error;
    }
  },

  // 削除された検索キーを持つユーザーの検索キーを削除
  deleteSearchKeys: async(tenantId: string, searchKeysName: string, searchKey: string): Promise<boolean> => {
    try {
      const users= collection(db, `companies/${tenantId}/users`);
      const deleteUsers = query(users, where(`searchKey${searchKeysName}`, "==", searchKey));
      const querySnapshot = await getDocs(deleteUsers)
      querySnapshot.forEach(async (document) => {
        const docRef = doc(db, `companies/${tenantId}/users`, document.id);
        if(searchKeysName == "1") {
          await updateDoc(docRef, {
            searchKey1: "", 
          });
        } else if (searchKeysName == "2") {
          await updateDoc(docRef, {
            searchKey2: "",
          });
        } else if (searchKeysName == "3") {
          await updateDoc(docRef, {
            searchKey3: "",
          });
        }
      });
      return true; 
    } catch (error) {
      console.error("エラーが発生しました:", error);
      return false; 
    }
  },

  // 利用者検索で一致する利用者を取得
  getUserSearch: async (companyId: String, userId: String) => {
    console.log("user getUserSearch access");
    let usersRef;
    const queries: any[] = [where('accountSuspensionFlg', '==', false)];

    // 利用者番号（完全一致検索）
    if (userId) {
      queries.push(where('displayId', '==', userId))
    }

    usersRef = await getDocs(query(
      collection(db, `companies/${companyId}/users`),
      ...queries,
    ));
    return usersRef.docs.map((doc) => doc.data());
  },
  // 取消対象のreadMessageを削除
  deleteReadMessage: async (tenantId: string, userId: string, messageId: string): Promise<boolean> => {
    console.log("user deleteReadMessage access");
    try {
      const ref = await getDocs(collection(db, `/companies/${tenantId}/users/${userId}/readMessages`));
      await Promise.all(ref.docs.map(async (document): Promise<void> => {
        if (document.id === messageId) {
          await deleteDoc(doc(db, document.ref.path));
        }
      }));
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  },

  // 取消対象のeventParticipationHistoryを削除
  deleteEventParticipationHistory: async (userId: string, messageId: string): Promise<boolean> => {
    console.log("user deleteEventParticipationHistory access");
    try {
      const q = query(
        collection(db, `messages/${messageId}/eventParticipationHistory`),
        where("userId", "==", userId)
      );
      const querySnapshot = await getDocs(q);
      await Promise.all(querySnapshot.docs.map(async (document): Promise<void> => {
        await deleteDoc(doc(db, document.ref.path));
      }));
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  // 利用者オプション設定情報更新
  updatepointAssignmentAuthorityData: async (tenantId: string, user: UserData, companyDisplayId: string): Promise<boolean> => {
    try {
      console.log("user updatepointAssignmentAuthorityData access");
      // 利用者情報更新(ポイント管理情報のみ)
      const userRef = doc(db, `/companies/${tenantId}/users`, user.id);
      const updateData: any = {
        admin: user.admin,
        pointAssignmentAuthority: user.pointAssignmentAuthority === undefined ? deleteField() : user.pointAssignmentAuthority,
        updateAt: new Date(),
      };
      // 運営者アプリを利用不可にした場合
      if(user.admin === false) {
        // ポイント管理を削除
        updateData.pointAssignmentAuthority = deleteField();
      }
      // ユーザ情報更新
      await updateDoc(userRef, updateData);
      // 役割を利用者に変更した場合
      if (user.admin === false) {
        // グループ管理者権限を削除
        const attendingGroupsRef = await getDocs(collection(db, `/companies/${tenantId}/users/${user.id}/attendingGroups`));
        const noChangeList = ["all",companyDisplayId];
        const changeAdminFlgList = attendingGroupsRef.docs.filter((doc) => !noChangeList.includes(doc.id));
        const beforeAdminFlgList = changeAdminFlgList.map((doc) => doc.data() as AttendingGroups);
        await Promise.all(beforeAdminFlgList.map(async (item) => {
          await updateDoc(
            doc(db,`/companies/${tenantId}/users/${item.userId}/attendingGroups`,`${item.id}`),
            {adminFlg: false});
        }));
      }
      return true;
    } catch (err) {
      console.error(err)
      return false;
    }
  },

  // 利用者の保有ポイント数を更新
  updatePossessedPointData: async (tenantId: string, userData: UserData, grantPoints: number, ptCategoryId: number, ptCategoryName: string ) => {
    let pointData = {};
    let point = grantPoints;
    if(userData.possessedPointMap){
      // 現在の保有ポイントに付与ポイントを加算
      let updateFlg = false;
      const keys = Object.keys(userData.possessedPointMap);
      if(keys && keys.length > 0){
        for(let i = 0; i < keys.length; i++){
          const key = Number(keys[i]);
          if(ptCategoryId === key){
            let totalPoint = (userData.possessedPointMap[key].point ?? 0) + grantPoints;
            if(totalPoint < 0){
              totalPoint = 0;
            }
            userData.possessedPointMap[key].point = totalPoint;
            updateFlg = true;
          };
        };
      };  
      if(!updateFlg){
        // 未登録のカテゴリの場合
        if(point < 0){
          point = 0;
        }
        Object.assign(userData.possessedPointMap,{ [ptCategoryId]: { id: ptCategoryId, name: ptCategoryName, point: point } });
      };
      pointData = userData.possessedPointMap;
    }else{
      // 保有ポイントマップが未登録の場合
      if(point < 0){
        point = 0;
      }
      Object.assign(pointData,{ [ptCategoryId]: { id: ptCategoryId, name: ptCategoryName, point: point } });
    };

    const userDocRef = doc(db, `companies/${tenantId}/users`, userData.id);
    await updateDoc(userDocRef, {
      possessedPointMap: pointData,
    });
  },

  /**
   * ポイント情報を含めた利用者詳細を取得
   * @param tenantId テナントID
   * @param userId 利用者ID
   * @returns 利用者情報取得結果
   */
  getUserData: async (tenantId: string, userId: string): Promise<UserData> => {
    console.log("user getUserData access");
    const userRef = await getDoc(
      doc(db, `/companies/${tenantId}/users`, userId)
    );
    const user = userRef.data();
    return user as UserData;
  },

  // 各登録数取得
  getCompanyUserCounts: async (companyId: string) => {
    const baseRef = collection(db, "companies", companyId, "users");
    
    // ID登録数
    const idRegisteredSnap = await getCountFromServer(
      query(baseRef, where("lastName", "!=", null), where("accountSuspensionFlg", "==", false))
    );

    // アプリ利用可能数
    const usableSnap = await getCountFromServer(
      query(baseRef, where("deleteFlg", "==", false), where("accountSuspensionFlg", "==", false))
    );

    // アプリ利用不可数
    const unusableSnap = await getCountFromServer(
      query(baseRef, where("deleteFlg", "==", true))
    );

    // アプリ利用停止数
    const suspendedSnap = await getCountFromServer(
      query(baseRef, where("accountSuspensionFlg", "==", true))
    );

    return {
      idRegistered: idRegisteredSnap.data().count,
      usable: usableSnap.data().count,
      unusable: unusableSnap.data().count,
      suspended: suspendedSnap.data().count,
    };
  },

  // グループの userCount を更新
  updateGroupUserCount: async (companyId: string, groupId: string, userCount: number) => {
    const groupRef = doc(db, `companies/${companyId}/groups`, groupId);
    await updateDoc(groupRef, {
      userCount,
      updateAt: new Date(),
    });
  },
}

export default userQuery;